import { render, staticRenderFns } from "./InfoPm.vue?vue&type=template&id=09b291b2&scoped=true"
import script from "./InfoPm.vue?vue&type=script&lang=js"
export * from "./InfoPm.vue?vue&type=script&lang=js"
import style0 from "./InfoPm.vue?vue&type=style&index=0&id=09b291b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b291b2",
  null
  
)

export default component.exports